<template>
    <v-dialog :value="value" persistent :transition="false">
        <v-card class="container">
            <MainView
                style="grid-area: mediamanager"
                elevation="0"
                session-key="mm-img-select-dialog"
                hide-multiselect
                :organizer-id="organizerId"
                @select-image="selectedImage = $event"
            />
            <v-card-actions class="elevation-0" style="grid-area: footer">
                <v-spacer />
                <PlainBtn @click="$emit('input', false)">{{ $t('cancel') }}</PlainBtn>
                <ActionBtn @click="$emit('select', selectedImage)">{{ $t('choose_img') }}</ActionBtn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import MainView from '@/components/media_manager/MainView.vue';
import { Image } from '@/models/Image';

/**
 * This dialog shows the media manager as a popup dialog, and allows to select an image to be inserted somewhere.
 *
 *
 * It emits the following events:
 * - input(false): If clicked on cancel, indicate the dialog close (to be used in v-model with value/input)
 * - select(image): Emits the selected image if the user clicks on ok
 */

export default {
    name: 'MediaManagerSelectImageDialog',
    components: {
        MainView,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },

        // already selected image
        initialImage: {
            type: Image,
            required: false,
            default: null,
        },
        organizerId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            selectedImage: this.initialImage || null,
        };
    },
};
</script>

<style lang="scss" scoped>
.container {
    height: 90vh;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    grid-template-columns: auto;
    grid-template-areas: 'mediamanager' 'footer';
}
</style>
